import type { Locale } from "../Locale.js";
import { getPathInLocale } from "./getPathInLocale.js";

export function getBlogPath(locale: Locale): string {
	return getPathInLocale(locale, "/blog");
}
